<div class="footer_container">
  <div
    [id]="item.id"
    class="footer_item"
    *ngFor="let item of navItems; let i = index"
    [ngClass]="{ selected: activeTab === i, create: i === 2 }"
    (click)="changeTab(i)"
  >
    <mat-icon
      *ngIf="fontLoaded"
      class="notranslate"
      [matBadgeHidden]="hideBadge(item)"
      [matBadge]="newMessagesCount"
    >
      {{ item.icon }}
    </mat-icon>
    <div *ngIf="!fontLoaded" class="loading_icon"></div>
    <p>{{ item.text }}</p>
  </div>
</div>
